<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <template v-if="warning.show">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Atenção!</h4>
                        <p class="mb-0">{{warning.message}}</p>
                    </div>
                </template>
                <template v-else-if="!loading">
                    <div class="row mb-3">
                        <div class="col">
                            <button class="btn btn-success btn-block" @click="selected_all">
                                <i class="fas fa-check-square mr-2"></i>Selecionar todos
                            </button>
                        </div>
                        <div class="col">
                            <button class="btn btn-danger btn-block" @click="unselected_all">
                                <i class="fas fa-ban mr-2"></i>Desmarcar todos
                            </button>
                        </div>
                    </div>
                    <div class="form-check p-0" v-for="(item, index) in clients" :key="index" :class="{'mt-2': index > 0}">
                        <label class="w-100 p-2 bg-white rounded" :for="`checkbox-${index}`" role="button">
                            <input class="form-check-input ml-0" type="checkbox" v-model="selected" :value="item._id" :id="`checkbox-${index}`">
                            <label class="form-check-label ml-4" :for="`checkbox-${index}`" role="button">
                                {{item.nome}}
                            </label>
                        </label>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-12">
                            <button class="btn btn-primary mr-2 btn-block" @click="validate">
                                <i class="fas fa-tools mr-2"></i>Corrigir evento
                            </button>
                        </div>
                    </div>
                </template>
            </div>            
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            block: true,
            clients: [],
            selected: [],
            loading: false,
            warning: {
                show: false,
                message: ''
            },
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        listClients() {

            const self = this;

            self.clients = [];
            self.loading = true;
            self.warning.show = false;

            api.get('list-clients').then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.clients = response.data.clients.sort((a, b) => {
                            return a.data_de_inicio > b.data_de_inicio ? 1 : a.data_de_inicio < b.data_de_inicio ? -1 : 0;
                        }).filter((item) => item.ativo == 1 || item.ativo == '1');
                    break;
                    case 'nothing_found':
                        self.warning.show = true;
                        self.warning.message = 'Nenhum cliente encontrado!';
                    break;
                    default:
                        self.warning.show = true;
                        self.warning.message = response.data.message;
                    break;
                }
            }).catch((error) => {
                try {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        async correctEvents() {

            try {
                
                const self = this;

                const { value: id } = await Swal.fire({
                    title: 'Recorrigir evento',
                    html: 'Informe o ID do evento',
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    customClass: 'sweet-only-custom',
                    inputPlaceholder: 'Informe o ID do evento',
                    confirmButtonText: 'Corrigir',
                    inputValidator: (value) => {

                        if (!value) {
                            return 'Informe o ID do evento!'
                        } else if (!value.match(/^[0-9a-fA-F]{24}$/)) {
                            return 'O ID informado é inválido!'
                        }
                    }
                });

                if (id) {
                    
                    self.loading = true;

                    api.post(`betting-correction`, {
                        id: id,
                        clients: self.selected
                    }).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                self.report(response.data.results);
                            break;
                            default: 
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha!',
                    'Ocorreu um erro, atualize a página!',
                    'error'
                );
            }
        },
        report(results) {
            
            let html = '';
            let count = 0;

            for (const item of results) {

                html += `
                    <div class="row pb-3 border-bottom ${count > 0 ? 'pt-3' : ''}">
                        <div class="col text-truncate">${item.cliente}</div>
                        <div class="col text-truncate ${(item.message.includes('erro') || item.message.includes('failed')) ? 'text-danger' : 'text-success'}">${item.message}</div>
                    </div>
                `; count++;
            }

            Swal.fire(
                `Relatório (${count})`,
                html
            );
        },
        validate() {
            if (this.selected.length == 0) {
                Swal.fire(
                    'Atenção!',
                    'Selecione pelo menos um cliente!',
                    'warning'
                );
            } else {
                this.correctEvents();
            }
        },
        selected_all() {
            this.clients.forEach((user) => {
                if (!this.selected.includes(user._id)) {
                    this.selected.push(user._id);
                }
            });
        },
        unselected_all() {
            this.selected = [];
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {
        this.listClients();
    }
}
</script>

<style scoped>
.form-check-input.ml-0 {
    margin-top: 7px;
}
</style>